import { HttpService } from "./http";

export interface PlannerEntry {
  id?: number;
  client_id?: number;
  clinic_id?: number;
  scheduled_datetime: string;
  name: string;
  type: string; // Exercise, Food, Drink, Lifestyle
  description?: string;
  status: 'pending' | 'completed' | 'ignored';
  completed_at?: string | null;
  ignored_at?: string | null;
  commented_at?: string | null;
  read_by_practitioner?: boolean;
  practitioner_comment?: string;
  file_id?: number;
  file?: {
    id: number;
    file: string;
    path: string;
    file_path?: string;
  };
  created_at?: string;
  updated_at?: string;
}

class HealthPlannerService extends HttpService {
  public constructor() {
    super("/client-app/health-suite/planner-entries");
  }

  public index(date?: string): Promise<PlannerEntry[]> {
    return this.http
      .get(this.route, {
        params: date ? { date } : {}
      })
      .then(this.handleResponse.bind(this))
      .catch(this.handleError.bind(this));
  }

  public show(entryId: number): Promise<PlannerEntry> {
    return this.http
      .get(`${this.route}/${entryId}`)
      .then(this.handleResponse.bind(this))
      .catch(this.handleError.bind(this));
  }

  public updateStatus(entryId: number, status: 'pending' | 'completed' | 'ignored', scheduledDatetime?: string): Promise<PlannerEntry> {
    return this.http
      .put(`${this.route}/${entryId}/status`, { status, scheduled_datetime: scheduledDatetime })
      .then(this.handleResponse.bind(this))
      .catch(this.handleError.bind(this));
  }

  public saveComment(entryId: number, comment: string): Promise<PlannerEntry> {
    return this.http
      .put(`${this.route}/${entryId}/comment`, { comment })
      .then(this.handleResponse.bind(this))
      .catch(this.handleError.bind(this));
  }
}

export const healthPlannerService = new HealthPlannerService(); 